import React from 'react';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: 'Immigration',
      image: '/assets/img/service-1.jpg',
      description: 'Comprehensive support for work permits, permanent residency, visitor visas, LMIA, spousal sponsorships, and more.',
      link: '/immigration'
    },
    {
      id: 2,
      title: 'Business Setup',
      image: '/assets/img/service-2.png',
      description: 'End-to-end assistance for launching a business in Canada—registration, CRA setup, licensing, banking, and digital presence.',
      link: '/business-setup'
    },
    {
      id: 3,
      title: 'Business Support',
      image: '/assets/img/service-3.png',
      description: 'Expert support for accounting, staffing, expansion, and digital tools to scale your business.',
      link: '/business-support'
    },
    // {
    //   id: 4,
    //   title: 'Students Visa',
    //   image: '/assets/img/service-1.jpg',
    //   description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    // },
    // {
    //   id: 5,
    //   title: 'Residence Visa',
    //   image: '/assets/img/service-2.jpg',
    //   description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    // },
    // {
    //   id: 6,
    //   title: 'Tourist Visa',
    //   image: '/assets/img/service-3.jpg',
    //   description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    // }
  ];

  return (
    <div className="container-fluid service overflow-hidden pt-5">
      <div className="container py-5">
        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">Service Categories</h5>
          </div>
          <h1 className="display-5 mb-4">Expert Immigration Support & Business Solutions Under One Roof</h1>
          <p className="mb-0">We provide complete support for your journey to Canada—covering everything from visas, work permits, and PR to business registration, planning, and growth. One team, one place, all the expertise you need to succeed.</p>
        </div>
        <div className="row g-4">
          {services.map((service, index) => (
            <div key={service.id} className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
              <div className="service-item">
                <div className="service-inner">
                  <div className="service-img">
                    <img src={service.image} className="img-fluid w-100 rounded" alt="Image" />
                  </div>
                  <div className="service-title">
                    <div className="service-title-name">
                      <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                        <Link to={service.link} className="h4 text-white mb-0">{service.title}</Link>
                      </div>
                      <Link to={service.link} className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4">Explore More</Link>
                    </div>
                    <div className="service-content pb-4">
                      <Link to={service.link}><h4 className="text-white mb-4 py-3">{service.title}</h4></Link>
                      <div className="px-4">
                        <p className="mb-4" style={{ color: '#fff' }}>{service.description}</p>
                        <Link to={service.link} className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5">Explore More</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection; 